import { createRoutine } from 'redux-saga-routines';

import { CHANGE_PASSWORD, GET_LANGUAGES, UPDATE_SETTINGS_PROPERTY, GET_ACCESS_REQUESTS } from './constants';

export const updateSettingsProperty = createRoutine(UPDATE_SETTINGS_PROPERTY);
export const getLanguages = createRoutine(GET_LANGUAGES);
export const changePasswordAction = createRoutine(CHANGE_PASSWORD);
export const getAccessRequestsAction = createRoutine(GET_ACCESS_REQUESTS);
